import * as React from "react"
import { cn } from "@/lib/utils"

export interface SliderProps extends React.InputHTMLAttributes<HTMLInputElement> {}
export function Slider({ className, ...props }: SliderProps) {
  // Deixa o controle com acentuação verde (bolinha e parte preenchida)
  // Utiliza accent-color, suportado pelos browsers modernos.
  return (
    <input
      type="range"
      className={cn("w-full accent-emerald-500", className)}
      {...props}
    />
  )
}
